import { render, staticRenderFns } from "./NewDeviceModal.vue?vue&type=template&id=17c3173e"
import script from "./NewDeviceModal.vue?vue&type=script&lang=js"
export * from "./NewDeviceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c3173e')) {
      api.createRecord('17c3173e', component.options)
    } else {
      api.reload('17c3173e', component.options)
    }
    module.hot.accept("./NewDeviceModal.vue?vue&type=template&id=17c3173e", function () {
      api.rerender('17c3173e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/Modal/NewDeviceModal.vue"
export default component.exports